import { render, staticRenderFns } from "./video-name.vue?vue&type=template&id=d7c2b26c&"
import script from "./video-name.vue?vue&type=script&lang=js&"
export * from "./video-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports